var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHebrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.33496H47.5V39.665H0.5V8.33496Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.272H47.5V16.1673H0.5V11.272Z",
    fill: "#0038B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 31.8325H47.5V36.7278H0.5V31.8325Z",
    fill: "#0038B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9994 17.2168L25.9575 20.6084H29.8738L27.9156 23.9999L29.8738 27.3915H25.9575L23.9994 30.7831L22.0413 27.3915H18.125L20.0831 23.9999L18.125 20.6084H22.0413L23.9994 17.2168ZM21.4195 21.6853H19.9904L20.7049 22.923L21.4195 21.6853ZM21.3267 23.9999L22.663 21.6853H25.3357L26.6721 23.9999L25.3357 26.3145H22.663L21.3267 23.9999ZM20.7049 25.0769L19.9904 26.3145H21.4195L20.7049 25.0769ZM23.2848 27.3915L23.9994 28.6291L24.7139 27.3915H23.2848ZM26.5793 26.3145H28.0084L27.2938 25.0769L26.5793 26.3145ZM27.2938 22.923L28.0084 21.6853H26.5793L27.2938 22.923ZM24.7139 20.6084H23.2848L23.9994 19.3707L24.7139 20.6084Z",
    fill: "#0038B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHebrew);
export default __webpack_public_path__ + "static/media/Hebrew.67580a68.svg";
export { ForwardRef as ReactComponent };